<template>
  <div class="statistics">
    <img :src="icon">
    <div class="statistics-text">{{text}}</div>
    <div class="statistics-value" :style="{color: types}" v-html="value"></div>
  </div>
</template>

<script>
export default {
  props: ['icon', 'text', 'value', 'type'],
  computed: {
    types() {
      return this.type
    }
  }
  
}
</script>

